import React, { useState } from 'react';
import { Box, TextField, Button, Typography } from '@mui/material';
import { useMutation } from "react-query";
import axios from 'axios';
import {url} from '../../BaseUrl'
const AddTeacher = () => {
  const [teacher, setTeacher] = useState({
    firstName: '',
    lastName: '',
    email: '',
    phone: '',
    subject: '',
    salary: '',
    hireDate: ''
  });

  const handleChange = (e) => {
    setTeacher({
      ...teacher,
      [e.target.name]: e.target.value,
    });
  };

  const mutation = useMutation({
    mutationFn: async (teacherData) => {
      const token = sessionStorage.getItem('token');
      const response = await axios.post(
        `${url}/api/auth/AddTeacher`,
        teacherData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json',
          },
        }
      );
      return response.data;
    },
    onSuccess: () => {
      alert('Teacher added successfully!');
      resetForm();
    },
    onError: (error) => {
      console.error('Error adding teacher:', error);
      alert('Failed to add teacher. Please try again.');
    },
  });

  const handleSubmit = (e) => {
    e.preventDefault();

    // Validate phone number length (assuming it should be 10 digits)
    if (!/^\d{10}$/.test(teacher.phone)) {
      alert('Phone number must be 10 digits.');
      return;
    }

    const teacherData = {
      ...teacher,
      salary: parseFloat(teacher.salary), // Ensure salary is a number
      hireDate: new Date(teacher.hireDate), // Convert date to ISO string
    };

    mutation.mutate(teacherData);
  };

  const resetForm = () => {
    setTeacher({
      firstName: '',
      lastName: '',
      email: '',
      phone: '',
      subject: '',
      salary: '',
      hireDate: ''
    });
  };

  return (
    <Box>
      <Typography variant="h4" gutterBottom align="center">
        Add Teacher
      </Typography>
      <form onSubmit={handleSubmit}>
        <Box sx={{ mb: 2 }}>
          <TextField
            fullWidth
            label="First Name"
            name="firstName"
            value={teacher.firstName}
            onChange={handleChange}
            required
            variant="outlined"
          />
        </Box>
        <Box sx={{ mb: 2 }}>
          <TextField
            fullWidth
            label="Last Name"
            name="lastName"
            type="text"
            value={teacher.lastName}
            onChange={handleChange}
            required
            variant="outlined"
          />
        </Box>
        <Box sx={{ mb: 2 }}>
          <TextField
            fullWidth
            label="Email"
            name="email"
            type="email"
            value={teacher.email}
            onChange={handleChange}
            required
            variant="outlined"
          />
        </Box>
        <Box sx={{ mb: 2 }}>
          <TextField
            fullWidth
            label="Phone"
            name="phone"
            type="tel"
            value={teacher.phone}
            onChange={handleChange}
            required
            variant="outlined"
          />
        </Box>
        <Box sx={{ mb: 2 }}>
          <TextField
            fullWidth
            label="Subject"
            name="subject"
            type="text"
            value={teacher.subject}
            onChange={handleChange}
            required
            variant="outlined"
          />
        </Box>
        <Box sx={{ mb: 2 }}>
          <TextField
            fullWidth
            label="Salary"
            name="salary"
            type="number"
            value={teacher.salary}
            onChange={handleChange}
            required
            variant="outlined"
          />
        </Box>
        <Box sx={{ mb: 2 }}>
          <TextField
            fullWidth
            label="Hire Date"
            name="hireDate"
            type="date"
            value={teacher.hireDate}
            onChange={handleChange}
            required
            variant="outlined"
            InputLabelProps={{ shrink: true }}
          />
        </Box>
        <Box sx={{ textAlign: 'center' }}>
          <Button
            type="submit"
            variant="contained"
            color="primary"
            disabled={mutation.isLoading}
          >
            {mutation.isLoading ? 'Adding...' : 'Add Teacher'}
          </Button>
        </Box>
      </form>
    </Box>
  );
};

export default AddTeacher;
